import { PaletteOptions } from "@mui/material/styles";

export default {
  primary: {
    darker: "#C35058",
    dark: "#FF7780",
    main: "#FDA4AA",
    light: "#FCD6D4",
    lighter: "#FCE3E3",
  },
  secondary: {
    dark: "#2BB4EF",
    main: "#5FCBFA",
    light: "#B9DDED",
    lighter: "#D6EDFA",
  },
  tertiary: {
    darker: "#35414D",
    dark: "#35414D",
    main: "#4D5966",
    light: "#5E6F80",
    lighter: "#5E6F80",
    contrastText: "#D6EDFA",
  },
  shadow: {
    white: "#FFFFFF",
    black: "#000000",
    main: "#828282",
    light: "#EBECED",
    dark: "#4F4F4F",
    darker: "#333333",
    contrastText: "#D6EDFA",
  },
  text: {
    primary: "#35414D",
    secondary: "#4D5966",
  },
  background: {
    default: "#D6EDFA",
    paper: "#FFFFFF",
  },
  info: {
    dark: "#2BB4EF",
    main: "#5FCBFA",
    light: "#B9DDED",
    lighter: "#D6EDFA",
  },
  warning: {
    darker: "#6B5B07",
    dark: "#B2980C",
    main: "#FDEFA4",
    light: "#FFF7CE",
    lighter: "#FFFADF",
  },
  success: {
    darker: "#245D13",
    dark: "#245D13",
    main: "#45AE22",
    light: "#98F19E",
    lighter: "#C9FFCD",
    contrastText: "#FFFFFF",
  },
  error: {
    dark: "#A62933",
    main: "#DF4854",
    light: "#FFBBBB",
    lighter: "#FDD0D0",
  },
} as PaletteOptions;
